/**
 * This is a simple phone number validator that checks whether a string is 10
 * digit phone number.
 * @param unformattedPhoneNumber Unformatted 10 digit phone number.
 * @returns Whether or not phone number is valid.
 */
export function phoneNumberIsValid(unformattedPhoneNumber: string): boolean {
  return (
    unformattedPhoneNumber.length === 10 && /^\d+$/.test(unformattedPhoneNumber)
  );
}

/**
 * Unformats a string phone number by removing all non-numeric characters.
 * @param formattedPhoneNumber Formatted phone number.
 * @returns Unformatted phone number.
 * */
export function unformatPhoneNumber(formattedPhoneNumber: string): string {
  return formattedPhoneNumber.replace(/\D/g, '');
}

/**
 * Simple phone number formatter that formats string into (xxx) xxx-xxxx format.
 * @param phoneNumberString 10 digit numbers.
 * @returns The formatted phone number in (xxx) xxx-xxxx format.
 */
export function formatPhoneNumber(phoneNumberString: string): string {
  const unformattedPhoneNumber = unformatPhoneNumber(phoneNumberString);
  const areaCode = unformattedPhoneNumber.substring(0, 3);
  const middle = unformattedPhoneNumber.substring(3, 6);
  const last = unformattedPhoneNumber.substring(6);

  if (unformattedPhoneNumber.length > 6) {
    return `(${areaCode}) ${middle}-${last}`;
  } else if (unformattedPhoneNumber.length > 3) {
    return `(${areaCode}) ${middle}`;
  } else if (unformattedPhoneNumber.length > 0) {
    return `(${areaCode}`;
  }
  return '';
}

/**
 * Formats any valid phone number to 10 digits.
 *
 * @param phoneNumber 10 or 11 digit phone number in any string format.
 * @returns The 10-digit version of the phone number.
 */
export function formatPhoneNumberToTenDigits(phoneNumber: string): string {
  const phoneNumberDigits = phoneNumber.replaceAll(/\D/g, '');
  if (phoneNumberDigits.length === 10) {
    return phoneNumberDigits;
  }
  if (phoneNumberDigits.length === 11 && phoneNumberDigits[0] === '1') {
    return phoneNumberDigits.slice(1);
  }
  return '';
}
